const textFieldConfirmCreateUser = {
  name: 'Nombre Completo',
  helperText: 'Ingrese su nombre completo',
  email: 'Email',
  password: 'Contraseña',
  helperTextPassword: 'Mínimo de 6 caracteres',
  confirmPassword: 'Confirme su contraseña',
  helperTextConfirmPassword: 'Contraseñas diferentes'
};

export default textFieldConfirmCreateUser;
